export {
  EmptyGame,
  type EmptyGameProps,
} from './EmptyGame';
